<script setup>
//region Imports
import { ref, onMounted, reactive } from 'vue'
import config from '../config/index.js'
//endregion
//region Methods
const saveData = data => {
  if (!data?.success) {
    const message = data?.message ?? 'Failed to fetch order'
    alert(message)
    console.error(new Error(message))
    submitButtonLabel.value = 'Next'
    return
  }

  const claims = data?.claims ?? [];

  localStorage.setItem('tc-claim-data', JSON.stringify(data?.order ?? {}))
  localStorage.setItem('tc-claim-claims', JSON.stringify(claims))

  if(claims.length > 0) {
    return location.replace('#/claims');
  }

  location.replace('#/order')
}

const readData = () => JSON.parse(localStorage.getItem('tc-claim-data'))

const onSubmit = event => {
  event.preventDefault()

  if (customerEmail.value.length === 0 || orderNumber.value.length === 0) {
    console.error(new Error('Please fill in all fields'))
    return
  }

  submitButtonLabel.value = 'Loading...'

  fetch(
      `${config.cloud.url}/api/shopify/order/shipping-protection/details/${customerEmail.value}/${orderNumber.value}`).
      then(response => response.json()).
      then(data => saveData(data)).
      catch(error => {
        console.error('Error:', error)
        submitButtonLabel.value = 'Next'
      })
}
//endregion
//region Variables
const data = reactive(readData() ?? {})
let orderNumber = ref(data?.orderNumber)
let submitButtonLabel = ref('Next')
let customerEmail = ref(data?.customerEmail)
const params = new URLSearchParams(location.search)
//endregion
//region Lifecycle
onMounted(() => {
  orderNumber.value = params.get('orderNumber') ?? data?.orderNumber
  customerEmail.value = params.get('customerEmail') ?? data?.customerEmail
})
//endregion
</script>

<template>
  <div class="flex flex-col lg:flex-row w-full lg:min-h-screen">

    <div class="w-full lg:w-6/12 h-[290px] lg:min-h-screen overflow-hidden bg-no-repeat bg-center bg-cover lg:order-last"
         style="background-image: url(https://cdn.shopify.com/s/files/1/0067/9532/9609/files/DSC00872_1_copy.png?v=1712945465);"
    >&nbsp;</div>

    <div class="w-full lg:w-6/12 px-[20px] lg:px-[40px] mt-[30px] lg:flex lg:justify-center lg:items-center">
      <div class="lg:max-w-[350px]">
        <div class="w-full lg:w-8/12">
          <h2 class="text-tc-title font-semibold leading-normal font-minionpro tracking-wider text-tc-black"
          >Resolve shipping problems</h2>

          <p class="text-tc-2xl font-normal text-black leading-normal my-[28px] font-avenir"
          >Was your package lost, damaged or stolen while being shipped? Then let's get it taken care of.
          </p>
        </div>
        <form class="relative flex flex-wrap gap-10" @submit="onSubmit">

          <h2 class="text-tc-2xl font-avenir font-bold tracking-wider text-black" v-text="'Start by entering your order details.'"></h2>

          <input required type="email" name="customerEmail" id="customerEmail" v-model="customerEmail"
                 placeholder="Email" class="font-avenir text-tc-2xl w-full text-black border-0 border-b border-tc-gray p-0 pb-2">

          <input required type="text" name="orderNumber" id="orderNumber" v-model="orderNumber"
                 placeholder="Order Number" class="font-avenir text-tc-2xl w-full text-black border-0 border-b border-tc-gray p-0 pb-2">

          <button type="submit"
                  class="w-full text-white text-tc-xl capitalize font-medium bg-tc-maroon h-[65px] font-avenir tracking-wider"
                  v-text="submitButtonLabel"
          >
          </button>

        </form>
      </div>
    </div>

  </div>
</template>

<style scoped>

</style>